import styled, { css } from 'styled-components';
var radioSize = '12px';
var RadioList = styled.div.withConfig({
  displayName: "RadioListstyles__RadioList",
  componentId: "sc-1atiffa-0"
})(["display:flex;flex-direction:column;align-items:center;margin-bottom:", ";font-family:", ";font-weight:", ";color:", ";"], function (props) {
  return props.hasBottomMargin ? '50px' : '0';
}, function (props) {
  return props.theme.font.family.brand;
}, function (props) {
  return props.theme.font.weight.regular;
}, function (props) {
  return props.disabled ? props.theme.color.monochrome.base : 'inherit';
});
var FieldSet = styled.fieldset.withConfig({
  displayName: "RadioListstyles__FieldSet",
  componentId: "sc-1atiffa-1"
})(["border:none;width:100%;overflow:hidden;"]);
var InnerContainer = styled.div.withConfig({
  displayName: "RadioListstyles__InnerContainer",
  componentId: "sc-1atiffa-2"
})(["display:flex;flex-direction:column;align-items:center;width:100%;overflow:hidden;"]);
var ContentContainer = styled.div.withConfig({
  displayName: "RadioListstyles__ContentContainer",
  componentId: "sc-1atiffa-3"
})(["", " width:100%;"], function (props) {
  return props.direction === 'row' && css(["display:flex;flex-direction:row;"]);
});
var RadioOption = styled.div.withConfig({
  displayName: "RadioListstyles__RadioOption",
  componentId: "sc-1atiffa-4"
})(["display:flex;width:100%;font-size:", ";align-items:", ";height:100%;flex-direction:row;padding:", ";text-align:left;position:relative;color:", ";", ""], function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.direction === 'row' ? 'center' : 'baseline';
}, function (props) {
  return props.padding;
}, function (props) {
  return props.disabled ? props.theme.color.monochrome.base : 'inherit';
}, function (props) {
  return props.direction === 'row' && css(["@media screen and (max-width:", "){padding:15px;}"], props.theme.size.breakpoint['max-width'].xs);
});
var Label = styled.label.withConfig({
  displayName: "RadioListstyles__Label",
  componentId: "sc-1atiffa-5"
})(["position:relative;display:flex;align-items:center;flex:1 1 50%;line-height:24px;flex-direction:column;cursor:pointer;&:not(:last-child){margin-bottom:", ";", "}.radioWrapper{width:100%;border-radius:", ";}"], function (props) {
  return "".concat(props.optionBottomMargin, "px");
}, function (props) {
  return props.direction === 'row' && css(["margin-right:", "px;"], props.optionRightMargin);
}, function (props) {
  return props.theme.size.border.radius.lg;
});
var LabelWrapper = styled.span.withConfig({
  displayName: "RadioListstyles__LabelWrapper",
  componentId: "sc-1atiffa-6"
})(["display:flex;flex-direction:column;"]);
var LabelValue = styled.span.withConfig({
  displayName: "RadioListstyles__LabelValue",
  componentId: "sc-1atiffa-7"
})(["flex-grow:1;font-weight:", ";", ""], function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.direction === 'row' && css(["@media screen and (max-width:", "){max-width:130px;}"], props.theme.size.breakpoint['max-width'].xs);
});
var LabelDescription = styled.span.withConfig({
  displayName: "RadioListstyles__LabelDescription",
  componentId: "sc-1atiffa-8"
})(["display:block;", ""], function (props) {
  return css(["@media screen and (max-width:", "){width:clamp(50%,60vw,100%);}"], props.theme.size.breakpoint['max-width'].xs);
});
var RightHandWrapper = styled.div.withConfig({
  displayName: "RadioListstyles__RightHandWrapper",
  componentId: "sc-1atiffa-9"
})(["margin-left:auto;align-self:", ";display:flex;align-items:center;height:calc(100% - 30px);@media all and (-ms-high-contrast:none){margin:", ";}"], function (_ref) {
  var verticalAlign = _ref.verticalAlign;
  return {
    bottom: 'flex-end',
    top: 'flex-start'
  }[verticalAlign] || 'center';
}, function (_ref2) {
  var verticalAlign = _ref2.verticalAlign;
  return {
    bottom: 'auto 0 0 auto',
    top: '0 0 auto auto'
  }[verticalAlign] || 'auto 0 auto auto';
});
var Circle = styled.div.withConfig({
  displayName: "RadioListstyles__Circle",
  componentId: "sc-1atiffa-10"
})(["position:relative;width:", ";height:", ";max-width:", ";max-height:", ";flex:0 0 ", ";border-radius:50%;font-size:", ";font-weight:600;border-color:transparent;margin-right:17px;top:0;box-shadow:0 0 0 2px ", ";background-color:", ";", ":hover &{box-shadow:0 0 0 2px ", ";}"], radioSize, radioSize, radioSize, radioSize, radioSize, function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.theme.color.monochrome.white;
}, Label, function (props) {
  return props.theme.color.monochrome.dark;
});
var Radio = styled.input.withConfig({
  displayName: "RadioListstyles__Radio",
  componentId: "sc-1atiffa-11"
})(["", ""], function (props) {
  return css(["height:100%;&:focus ~ .radioWrapper{outline:", " auto 5px;outline-offset:-4px;}&:checked ~ .radioWrapper{background-color:", ";border:", " solid ", ";border-color:", ";&:hover{border-color:", ";}", "{background-color:", ";border:2px solid ", ";box-shadow:0 0 0 2px ", ";", ":hover &{background-color:", ";box-shadow:0 0 0 2px ", ";}}}&:not(:checked) ~ .radioWrapper{border:", " solid ", ";border-color:", ";&:hover{background-color:", ";border-color:", ";}}&:disabled ~ .radioWrapper{background-color:", ";border-color:", ";&:hover{cursor:not-allowed;", "{box-shadow:0 0 0 2px ", ";background-color:", ";", ":hover &{box-shadow:0 0 0 2px ", ";}}}}&:disabled:checked ~ .radioWrapper{", "{box-shadow:0 0 0 2px ", ";background-color:", ";}&:hover{", "{background-color:", ";}}}"], props.theme.color.palette['brand-1'], props.hasBackground ? props.theme.color.palette['brand-1-light'] : 'none', props.theme.size.border.width.sm, props.theme.color.monochrome.base, props.border ? props.theme.color.palette['brand-1'] : props.theme.color.palette['brand-1-light'], props.border ? props.theme.color.palette['brand-1-dark'] : 'transparent', Circle, props.theme.color.palette['brand-1'], props.theme.color.monochrome.white, props.theme.color.palette['brand-1'], Label, props.theme.color.palette['brand-1-dark'], props.theme.color.palette['brand-1-dark'], props.theme.size.border.width.sm, props.theme.color.monochrome.base, props.border ? props.theme.color.monochrome.base : 'transparent', props.theme.color.monochrome.lighter, props.border ? props.theme.color.monochrome.base : 'transparent', props.theme.color.monochrome.lighter, props.border ? props.theme.color.monochrome.base : 'transparent', Circle, props.theme.color.monochrome.base, props.theme.color.monochrome.white, Label, props.theme.color.monochrome.base, Circle, props.theme.color.monochrome.base, props.theme.color.monochrome.base, Circle, props.theme.color.monochrome.base);
});
export { Circle, ContentContainer, InnerContainer, FieldSet, Label, LabelWrapper, LabelValue, LabelDescription, Radio, RadioList, RadioOption, RightHandWrapper };